module.exports = __webpack_public_path__ + "media/images/default_card_doc_image-ee53022b330c696d97d5a0779ae6a725.jpg";